module.exports = __webpack_public_path__ + "media/images/plus-b43d7ab0f5b12d2b6d4ba40dec2efd05.svg";